const MAX_FILE_SIZE = 5 * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

export interface ImageValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateImageFile = (file: File): ImageValidationResult => {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return {
      isValid: false,
      error: 'Invalid file type. Please upload JPEG, PNG, or WebP images only.',
    };
  }

  return { isValid: true };
};

export const validateImageSize = (file: File): ImageValidationResult => {
  if (file.size > MAX_FILE_SIZE) {
    return {
      isValid: false,
      error: `File size exceeds 5MB. Please upload a smaller image.`,
    };
  }

  return { isValid: true };
};

export const validateImage = (file: File): ImageValidationResult => {
  const typeValidation = validateImageFile(file);
  if (!typeValidation.isValid) {
    return typeValidation;
  }

  const sizeValidation = validateImageSize(file);
  if (!sizeValidation.isValid) {
    return sizeValidation;
  }

  return { isValid: true };
};

export const createPreviewUrl = (file: File): string => {
  return URL.createObjectURL(file);
};

export const cleanupPreviewUrl = (url: string): void => {
  if (url && url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
};

export const cleanupPreviewUrls = (urls: string[]): void => {
  urls.forEach(url => cleanupPreviewUrl(url));
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};
